export default "__VITE_ASSET__Ba66WMrN__"